import { serviceUrls } from '../config/serviceUrls';

/** Resolve platform avatar URLs (absolute blob URL or gateway-relative /static path). */
export function resolveAvatarUrl(avatarUrl?: string | null): string | null {
  if (!avatarUrl?.trim()) return null;
  const trimmed = avatarUrl.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('data:')) {
    return trimmed;
  }
  if (trimmed.startsWith('/')) {
    return `${serviceUrls.gateway.replace(/\/$/, '')}${trimmed}`;
  }
  return trimmed;
}
